import { ref } from 'vue'
import { useAuthStore } from '@/stores/useAuthStore'
import { useRouter } from 'vue-router'
import useAuthApi from '@/composables/useAuthApi'

export default function useImpersonate() {
  const loading = ref(false)
  const error = ref<any>()

  const router = useRouter()
  const authApi = useAuthApi()
  const { logOut } = useAuthStore()

  async function impersonate(payload: any) {
    try {
      loading.value = true
      await authApi.post('api/auth/impersonate', payload)
      localStorage.setItem('meta', 'true')
      await router.push('/');
      window.location.reload();
    } catch (err: any) {
      error.value = err
      if (err?.response?.status === 401) {
        logOut()
      }
    } finally {
      loading.value = false
    }
  }

  return { impersonate, error, loading }
}